export function error(state) {
  return state.error;
}

export function errorMessage(state) {
  return state.errorMessage;
}

export function getFormattedDate() {
  return (strdate, replaceTimeZone = false) => {
    strdate = strdate.toString();

    if (replaceTimeZone || strdate.search('T') == -1) {
      let today = new Date();
      today.setHours(0, 0, 0);
      let strDateParts = strdate.split('T');
      let strTodayParts = today.toISOString().split('T');
      strdate = strDateParts[0] + 'T' + strTodayParts[1];
    }
    let date = new Date(strdate);
    let day = date.getDate();
    let year = date.getFullYear();
    const months = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];
    const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    let dayName = days[date.getDay()];
    day = date.getDate();
    let monthName = months[date.getMonth()];
    year = date.getFullYear();
    day = day < 10 ? '0' + day : day;
    let formatted = `${dayName}, ${monthName} ${day}`;
    return formatted;
  };
}

export function formatAMPM(state) {
  return (strdate) => {
    let date = new Date(strdate);
    return AmPmInternal(date.getHours(), date.getMinutes());
  };
}

export function formatAMPMHour(state) {
  return (strHour) => {
    let splitText = strHour.split(':');
    return AmPmInternal(parseInt(splitText[0]), parseInt(splitText[1]));
  };
}

function AmPmInternal(hours, minutes) {
  let ampm = hours >= 12 ? 'pm' : 'am';
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  minutes = minutes < 10 ? '0' + minutes : minutes;
  let strTime = hours + ':' + minutes + ' ' + ampm;
  return strTime;
}

